module.exports = __webpack_public_path__ + "static/media/campground.f01834f6.svg";